import LAYOUT_CONST from "@constant";

export const JWT_API = {
  secret: process.env.REACT_APP_SECRET,
  timeout: process.env.REACT_APP_TIME_OUT,
};

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const AUTH0_API = {
  client_id: process.env.REACT_APP_CLIENT_ID,
  domain: process.env.REACT_APP_DOMAIN,
};

export const AWS_API = {
  poolId: process.env.REACT_APP_POOL_ID,
  appClientId: process.env.REACT_APP_APP_CLIENT_ID,
};

export const API_URL = process.env.REACT_APP_API_URL;

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const FBGRAPH_URL = process.env.REACT_APP_FBGRAPH_URL;

export const BASE_PATH = "";

export const DASHBOARD_PATH = "/dashboard/default";
export const DASHBOARD_PATH_INITIATED = "/dashboard/default";

// xsmtpsib-f12c60a9e20d18c4ada832fb7e7baf10c022c8cc5e18ea415d2d50481e876b84-XCy1gJjGncAVp02r
// SMTP KEY

// onsibo key brevo:
// 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

export const HORIZONTAL_MAX_ITEM = 6;

const timeOfDay = () => {
  const now = new Date();
  const hour = now.getHours();
  const isDayTime = hour >= 6 && hour < 18;
  return isDayTime ? "light" : "light";
};

const paletteMode = timeOfDay();

export const statusList = [
  { value: "0", label: "Draft" },
  { value: "1", label: "Sent" },
  { value: "2", label: "Open" },
  { value: "3", label: "Revised" },
  { value: "4", label: "Declined" },
  { value: "5", label: "Accepted" },
];

export const invoiceStatusList = [
  { value: "0", label: "Unpaid" },
  { value: "1", label: "Overdue" },
  { value: "2", label: "Due Today" },
  { value: "3", label: "Paid" },
];

export const ProjectStatusList = [
  { value: 0, label: "Not started" }, //open
  { value: 1, label: "Started" }, // in progress
  { value: 2, label: "In progress" }, // in progress
  { value: 3, label: "Waiting" }, // waiting
  { value: 4, label: "Cancelled" },
  { value: 5, label: "Complete" }, //complete
];

export const ProjectStatus = [
  { value: 0, label: "Not started" }, //open
  { value: 1, label: "Started" }, // in progress
  { value: 2, label: "Declined" }, // waiting
  { value: 3, label: "Completed" },
];

export const categoryList = [
  { value: 1, label: "Gas" },
  { value: 2, label: "Toll road" },
  { value: 3, label: "Insurance" },
  { value: 4, label: "Cell" },
  { value: 5, label: "Utilities" },
  { value: 6, label: "Meals and entertainment" },
  { value: 7, label: "Supplies" },
  { value: 8, label: "Office expenses" },
  { value: 9, label: "Advertising" },
  { value: 10, label: "Sales taxes" },
  { value: 11, label: "Payroll" },
];

export const accountList = [
  { value: 0, label: "Account 1" },
  { value: 1, label: "Account 2" },
];

export const orderPriorityList = [
  { value: "0", label: "Low" },
  { value: "1", label: "Medium" },
  { value: "2", label: "High" },
];

//     0: "Draft",
//     1: "Sent",
//     2: "Open",
//     3: "Revised",
//     4: "Declined",
//     5: "Accepted",

const config = {
  layout: LAYOUT_CONST.VERTICAL_LAYOUT, // vertical, horizontal
  drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
  fontFamily: `'DM Sans', sans-serif`,
  borderRadius: 3,
  outlinedFilled: true,
  // navType: 'dark', // light, dark
  navType: paletteMode, // light, dark auto by day hours
  presetColor: "theme6", // default, theme1, theme2, theme3, theme4, theme5, theme6
  locale: "es", // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
  rtlLayout: false,
  container: true,
};

export function pushLocalStorage(value, listName) {
  let listaActual = localStorage.getItem(listName);
  if (!listaActual) {
    listaActual = [];
  } else {
    listaActual = JSON.parse(listaActual);
  }
  listaActual.push(value);
  localStorage.setItem(listName, JSON.stringify(listaActual));
}

export function getLocalStorageList(listName) {
  const lista = localStorage.getItem(listName);
  if (lista) {
    return JSON.parse(lista);
  } else {
    return [];
  }
}

export function deleteValueFromLocal(key, value, listName) {
  let listaActual = localStorage.getItem(listName);
  if (!listaActual) {
    return; // Si no hay lista, no hacemos nada.
  }

  listaActual = JSON.parse(listaActual);

  // Filtramos la lista eliminando los elementos que coinciden con el criterio
  const listaActualizada = listaActual.filter((item) => item[key] !== value);

  // Guardamos la lista actualizada en localStorage
  localStorage.setItem(listName, JSON.stringify(listaActualizada));
}

export default config;
